import React from "react";
import './Shipping_policy.css';

const Shipping_policy = () => {
  return (
    <div className="shipping-policy-ap row">
      <div className="shipping-policy-wrap col-xl-12">

        {/* HERO */}
        <section className="shipping-policy-hero">
          <h1>Shipping Policy</h1>
          <p>Fast. Reliable. Thoughtfully Delivered.</p>
          <p>At Garshya, delivery isn’t just logistics — it’s part of the experience. We focus on ensuring your order reaches you safely, on time, and exactly as expected.</p>
        </section>

        {/* SECTIONS */}
        <section className="shipping-policy-section">

          <h2>Order Processing</h2>
          <ul>
            <li>All orders are processed within 24–48 business hours after confirmation</li>
            <li>Orders with advance payment (including COD orders) are prioritized for faster dispatch</li>
            <li>Orders are processed only on business days (Monday to Saturday), excluding public holidays</li>
          </ul>

          <h2>Estimated Delivery Time</h2>
          <p>Delivery timelines may vary depending on your location, product availability, and serviceability.</p>
          <ul>
            <li>Metro Cities: 2–4 business days</li>
            <li>Tier 2 & Tier 3 Cities: 3–6 business days</li>
            <li>Remote Areas: 5–8 business days</li>
          </ul>
          <p>Estimated delivery timelines are displayed on the product page and at checkout for transparency.</p>

          <h2>Shipping Charges</h2>
          <ul>
            <li>Shipping charges (if applicable) will be clearly displayed at checkout</li>
            <li>We aim to keep shipping fair, transparent, and value-driven</li>
            <li>Occasionally, free shipping offers may be available on select products or order values</li>
          </ul>

          <h2>Serviceable Locations</h2>
          <ul>
            <li>We currently deliver across India</li>
            <li>Delivery availability depends on:
              <ul>
                <li>your pincode</li>
                <li>product type</li>
                <li>partner logistics coverage</li>
              </ul>
            </li>
          </ul>
          <p>If your location is not serviceable, you will be notified during checkout.</p>

          <h2>Delivery Process</h2>
          <ul>
            <li>Orders are shipped through trusted logistics partners</li>
            <li>You will receive:
              <ul>
                <li>Order confirmation</li>
                <li>Shipping updates</li>
                <li>Tracking details</li>
              </ul>
            </li>
          </ul>
          <p>We ensure that every package is handled with care to maintain product quality.</p>

          <h2>Cash on Delivery (COD) Orders</h2>
          <ul>
            <li>COD orders are processed only after 10% advance payment confirmation</li>
            <li>Maximum COD order value: ₹3,000</li>
            <li>Orders may be verified before dispatch to ensure authenticity</li>
          </ul>
          <p>This helps us maintain a premium and reliable delivery experience.</p>

          <h2>Delays & Exceptions</h2>
          <ul>
            <li>Unforeseen logistics issues</li>
            <li>Weather conditions</li>
            <li>Public holidays or regional restrictions</li>
          </ul>
          <p>In such cases, we will keep you informed and ensure resolution at the earliest.</p>

          <h2>Important Notes</h2>
          <ul>
            <li>Delivery timelines are estimates, not guarantees</li>
            <li>Garshya reserves the right to:
              <ul>
                <li>limit or refuse delivery in certain areas</li>
                <li>cancel orders due to logistical or operational constraints</li>
              </ul>
            </li>
            <li>In case of non-delivery but status marked delivered, please contact us within 48 hours for investigation</li>
          </ul>

          <p>Garshya delivers more than products. We deliver trust, carefully packed.</p>
        </section>

      </div>
    </div>
  );
};

export default Shipping_policy;